(function(root,factory){
 const model=factory();
 if(typeof module==='object'&&module.exports)module.exports=model;
 else root.BB_BOX3=model;
})(typeof globalThis!=='undefined'?globalThis:this,function(){
 'use strict';
 // One box, one set of counts. No modes: every flavor row has its own − / + control.
 const keys=['variety','lemon','tropical','pm'];
 const empty=()=>Object.fromEntries(keys.map(k=>[k,0]));
 const count=s=>keys.reduce((n,k)=>n+s.counts[k],0);
 const selected=s=>keys.filter(k=>s.counts[k]>0);
 const create=()=>({flavor:'variety',counts:{variety:2,lemon:0,tropical:0,pm:0},sub:true,every:21});
 function quantity(n){return Math.max(0,Math.min(99,Math.trunc(Number(n)||0)));}
 // Picking a flavor from the hero or lineup: a one-flavor box switches flavor and keeps its
 // bag count; a mixed box simply gains that flavor (one bag) if it is not already in it.
 function pick(s,key){
  if(!keys.includes(key))return;
  s.flavor=key;
  if(selected(s).length<=1){const n=count(s)||1;s.counts=empty();s.counts[key]=n;}
  else if(!s.counts[key])s.counts[key]=1;
 }
 // Browsing the hero gallery: switch flavor only while the box holds a single flavor.
 function browse(s,key){if(!keys.includes(key))return;if(selected(s).length<=1)pick(s,key);else s.flavor=key;}
 function change(s,key,delta){if(!keys.includes(key))return;s.counts[key]=quantity(s.counts[key]+delta);if(delta>0||s.counts[key])s.flavor=key;}
 function each(s){s.counts=Object.fromEntries(keys.map(k=>[k,1]));s.flavor='variety';}
 function quote(s,n=count(s),sub=s.sub,pricing={full:2499,one2:2250,one3:2125,sub:2249}){
  const unit=sub?pricing.sub:n>=3?pricing.one3:n===2?pricing.one2:pricing.full;
  return {bags:n,sticks:n*20,unit,total:n*unit,saved:n*pricing.full-n*unit};
 }
 function variant(products,key){return products[key]?.variants?.find(v=>v.available)||products[key]?.variants?.[0];}
 function allocation(v,cfg,every){return v?.selling_plan_allocations?.find(a=>Number(a.selling_plan_id)===Number(cfg.plans[every]));}
 function items(s,products,cfg){
  if(!count(s))throw Error('Choose at least one bag for your box.');
  if(cfg.currency!=='USD')throw Error('This box is currently available with USD pricing.');
  const mode=selected(s).length>1?'mix':'single';
  return selected(s).map(k=>{
   const v=variant(products,k);
   if(!v?.available||v.price!==cfg.pricing.full)throw Error(cfg.names[k]+' is currently unavailable at this price. Please adjust your box.');
   if(s.sub&&allocation(v,cfg,s.every)?.price!==cfg.pricing.sub)throw Error('The selected subscription is unavailable for '+cfg.names[k]+'. Please adjust your box.');
   const item={id:Number(v.id),quantity:s.counts[k],properties:{_bb_design:cfg.design,_bb_experiment:'buzz-bomb-ui-20261103',_bb_box_mode:mode}};
   if(s.sub)item.selling_plan=Number(cfg.plans[s.every]);
   return item;
  });
 }
 return {keys,empty,count,selected,create,pick,browse,change,each,quote,variant,allocation,items};
});
